import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { theme } from './theme/theme';
import './theme/robotoFont';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UploadPage from './pages/UploadPage';
import ExcelMappingPage from './pages/ExcelMappingPage';
import UsersListPage from './pages/UsersListPage';
import UserFormPage from './pages/UserFormPage';
import AuditLogsPage from './pages/AuditLogsPage';
import ExportCsvPage from './pages/ExportCsvPage';
import ConfigProfilesPage from './pages/ConfigProfilesPage';
import TemplatesPage from './pages/TemplatesPage';
import ManageFilesDashboardPage from './pages/ManageFilesDashboardPage';
import ManageFilesProcessPage from './pages/ManageFilesProcessPage';
import ProtectedRoute from './router/ProtectedRoute';
import Layout from './components/Layout';
import useAuth from './hooks/useAuth';
import { useEffect } from 'react';

const RoutedApp: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    try {
      const token = localStorage.getItem('accessToken');
      if (token && (location.pathname === '/' || location.pathname === '/login')) {
        navigate('/dashboard', { replace: true });
      }
    } catch {}
  }, [location.pathname, navigate]);

  return (
    <Routes>
      {/* Ruta Pública */}
      <Route path="/login" element={<LoginPage login={login} />} />

      {/* Rutas Protegidas (Requieren JWT) */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={
          <Layout>
            <DashboardPage />
          </Layout>
        } />
        <Route path="/dashboard" element={
          <Layout>
            <DashboardPage />
          </Layout>
        } />
        <Route path="/upload" element={
          <Layout>
            <UploadPage />
          </Layout>
        } />
        <Route path="/excel-mapping" element={
          <Layout>
            <ExcelMappingPage />
          </Layout>
        } />
        <Route path="/users" element={
          <Layout>
            <UsersListPage />
          </Layout>
        } />
        <Route path="/users/new" element={
          <Layout>
            <UserFormPage />
          </Layout>
        } />
        <Route path="/users/:id/edit" element={
          <Layout>
            <UserFormPage />
          </Layout>
        } />
        <Route path="/audit-logs" element={
          <Layout>
            <AuditLogsPage />
          </Layout>
        } />
        <Route path="/export-csv" element={
          <Layout>
            <ExportCsvPage />
          </Layout>
        } />
        <Route path="/templates" element={
          <Layout>
            <TemplatesPage />
          </Layout>
        } />
        <Route path="/config/environments" element={
          <Layout>
            <ConfigProfilesPage />
          </Layout>
        } />
        <Route path="/manage-files/dashboard" element={
          <Layout>
            <ManageFilesDashboardPage />
          </Layout>
        } />
        <Route path="/manage-files/process" element={
          <Layout>
            <ManageFilesProcessPage />
          </Layout>
        } />
        <Route path="/manage-files/loggins" element={
          <Layout>
            <ManageFilesDashboardPage />
          </Layout>
        } />
      </Route>
      
      {/* Ruta de fallback si no encuentra ninguna (404) */}
      <Route path="*" element={
        <Layout>
          <Box sx={{ textAlign: 'center', padding: '2rem' }}>
            <h1>404 | Página no encontrada</h1>
          </Box>
        </Layout>
      } />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <RoutedApp />
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;